import { Button, HelpIcon } from '@platform/components';
import { BUSINESS_CHALLENGES, CreateProjectContext } from './consts';
import { ROUTES } from '../routes/consts';
import { useContext } from 'react';
import { Link } from 'wouter';
import dataTestids from '../constants/test-ids';

const BusinessChallengeStep = () => {
  const { setBusinessChallenge } = useContext(CreateProjectContext);
  return (
    <>
      <div>What business challenge do you need support with? Select one category at a time.</div>
      <div className='w-full flex flex-col gap-2'>
        {BUSINESS_CHALLENGES.map((challenge) => (
          <div
            key={challenge.name}
            className='bg-white p-4 flex items-center gap-2'
            data-testid={dataTestids.CREATE_PROJECT.BUSINESS_CHALLENGE_ROW}
          >
            <div className='font-semibold'>{challenge.name}</div>
            <HelpIcon supportingText={challenge.description} />
            <div className='ml-auto'>
              <Link to={ROUTES.CREATE_PROJECT + '/2'} asChild>
                <Button
                  size='lg'
                  variant='link-color'
                  tailIcon='arrow-right'
                  onPress={() => {
                    setBusinessChallenge(challenge.name);
                  }}
                  data-testid={`${dataTestids.CREATE_PROJECT.BUSINESS_CHALLENGE_SELECT_BUTTON}`}
                >
                  Select
                </Button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default BusinessChallengeStep;
